import React from "react";
import PhotoUploaderWithSwitch from "components/campaign/campaignCreation/PhotoUploaderWithSwitch";
import { 
  campaignCreationStepTwoGeneralSectionConfig, 
  CREATION_STEP_THREE_CONFIG as CAMPAIGN_CREATION_STEP_THREE_CONFIG
} from "containers/engagement/campaign/CampaignCreationConfig";
import config from 'config';
import FeaturedOrExclusiveCampaignRadio from "components/campaign/campaignCreation/FeaturedOrExclusiveCampaignRadio";
import StampIconUploader from "./StampIconUploader";
import RewardSection from "./RewardSection";
import ReactHookFormMarkDownArea from "components/reactHookFormComponents/ReactHookFormMarkDownArea";
import TaskSection from "./TaskSection";
import ContentLanguageCard from "components/campaign/campaignCreation/ContentLanguageCard";
import ApprovalCheckList from "components/campaign/campaignCreation/ApprovalCheckList";
import ProfileSection from "./ProfileSection";
import ReactHookFormTextInput from "components/reactHookFormComponents/ReactHookFormTextInput";

export const CREATION_STEP_ONE_CONFIG = {
  extraValidate: ({ getValues, setError, clearErrors }) => true,
  getDisplayComponentKeys: ({ formContext: { watch } }) => {
    const isExclusive = watch("isExclusive")
    let displayLanguageSectionComponents = campaignCreationStepTwoGeneralSectionConfig.keys;
    displayLanguageSectionComponents = [
      ...displayLanguageSectionComponents,
      "cover_photo_upload_key",
      "featured_or_exclusive_campaign_key",
        ...(isExclusive ? [
          "square_cover_photo_upload_key",
        ] : []),
      "other_photo_upload_key",
      "stamp_campaign_upload_stamp_icon_key",
      "task_section_key",
      "reward_section_key",
      "instruction_section_key",
      "detail_section_key",
    ]

    return {
      displayNormalSectionComponents: [],
      displayLanguageSectionComponents
    }
  },
  normalSections: [],
  languageSections: [
    campaignCreationStepTwoGeneralSectionConfig.section,
    {
      sectionTitle: "key_visual",
      description: "campaign.cover_photo_reminder",
      descriptionClass: "tips-message",
      sectionContent: [
        {
          key: "cover_photo_upload_key",
          component: PhotoUploaderWithSwitch,
          componentProps: {
            withTranslation: true,
            title: "cover_photo",
            tips: "cover_photo_suggest_with_variable",
            wordTranslationVariable: config.campaignRectangleSize,
            tranlationFieldPrefix: "translations",
            photoFieldName: "coverPhoto",
            activeSectionKey: "coverPhoto",
            switchConfig: {
              fieldName: "applyCoverPhotoToAllLanguage",
              title: "Apply to all language",
            },
            uploaderAspect: 900 / config.campaignRectangleSize.minHeight,
            minWidth: 900,
            minHeight: config.campaignRectangleSize.minHeight,
          },
        },
        {
          key: "featured_or_exclusive_campaign_key",
          component: FeaturedOrExclusiveCampaignRadio,
        },
        {
          key: "square_cover_photo_upload_key",
          component: PhotoUploaderWithSwitch,
          componentProps: {
            withTranslation: true,
            title: "campaign.square_cover_photo",
            tips: "square_cover_photo_suggest_with_variable",
            wordTranslationVariable: config.campaignSquareSize,
            tranlationFieldPrefix: "translations",
            photoFieldName: "squareCoverPhoto",
            activeSectionKey: "squareCoverPhoto",
            switchConfig: {
              fieldName: "applySquareCoverPhotoToAllLanguage",
              title: "Apply to all language",
            },
            uploaderAspect: config.campaignSquareSize.minWidth / config.campaignSquareSize.minHeight
          },
        },
        {
          key: "other_photo_upload_key",
          component: PhotoUploaderWithSwitch,
          componentProps: {
            withTranslation: true,
            title: "other_photos",
            tips: "cover_photo_suggest_with_variable",
            wordTranslationVariable: config.campaignRectangleSize,
            tranlationFieldPrefix: "translations",
            photoFieldName: "detailPhotos",
            activeSectionKey: "otherPhotos",
            switchConfig: {
              fieldName: "applyDetailPhotosToAllLanguage",
              title: "Apply to all language",
            },
            uploaderAspect: 900 / config.campaignRectangleSize.minHeight,
            minWidth: 900,
            minHeight: config.campaignRectangleSize.minHeight,
            maxImageNum: 4
          },
        },
        {
          key: "stamp_campaign_upload_stamp_icon_key",
          component: StampIconUploader,
        },
      ]
    },
    {
      sectionContent: [
        {
          key: "task_section_key",
          component: TaskSection,
        }
      ]
    },
    {
      sectionContent: [
        {
          key: "reward_section_key",
          component: RewardSection,
        }
      ]
    },
    {
      sectionContent: [{
        key: "instruction_section_key",
        component: ReactHookFormMarkDownArea,
        componentProps: {
          hasTranslation: true,
          areaTitle: "instruction",
          titleConfig: {
            label: "instruction_section_title",
            valueFieldName: "translations.{{language}}.instructionSectionTitle",
            disableFocusChange: false,
            focusChangeKey: "instructionTitle",
          },
          contentConfig: {
            label: "instruction_section_content",
            valueFieldName: "translations.{{language}}.instructionSectionContent",
            disableFocusChange: false,
            focusChangeKey: "instructionContent",
          },
        },
      }]
    },
    {
      sectionContent: [{
        key: "detail_section_key",
        component: ReactHookFormMarkDownArea,
        componentProps: {
          hasTranslation: true,
          areaTitle: "detail",
          titleConfig: {
            label: "detail_section_title",
            valueFieldName: "translations.{{language}}.detailSectionTitle",
            disableFocusChange: false,
            focusChangeKey: "detailsTitle",
          },
          contentConfig: {
            label: "detail_section_content",
            valueFieldName: "translations.{{language}}.detailSectionContent",
            disableFocusChange: false,
            focusChangeKey: "detailsContent",
          },
        },
      }]
    },
  ]
}

export const CREATION_STEP_TWO_CONFIG = {
  ...CAMPAIGN_CREATION_STEP_THREE_CONFIG,
  getDisplayComponentKeys: (...props)=> {
    const {
      displayNormalSectionComponents,
      displayLanguageSectionComponents
    } = CAMPAIGN_CREATION_STEP_THREE_CONFIG.getDisplayComponentKeys(...props)
    return {
      displayNormalSectionComponents: [...displayNormalSectionComponents, "execution_priority_input_key"],
      displayLanguageSectionComponents,
    }
  },
  normalSections: [
    {
      sectionTitle: "EXECUTION PRIORITY",
      sectionContent: [
        {
          key: "execution_priority_input_key",
          component: ReactHookFormTextInput,
          componentProps: {
            customClass: "width-160px",
            type: "number",
            valueFieldName: 'executionPriority',
            title: 'Execution priority',
            tips: "Set the priority for executing earning rules linked to stamp campaigns. If a single earning rule is connected to multiple stamp campaigns and when the earning rule is triggered, the customer has reached the global reward limit, this execution priority will determine which stamp campaign should issue the stamp reward.",
            shortDescription: "Minimum value is 1. The smaller value, the higher priority."
          }
        }
      ],
    },
    ...CAMPAIGN_CREATION_STEP_THREE_CONFIG.normalSections,
  ]
}

export const CREATION_STEP_THREE_CONFIG = {
    extraValidate: ({ getValues, setError, clearErrors }) => true,
    getDisplayComponentKeys: ({ formContext: { watch } }) => {
      return {
        displayNormalSectionComponents: [],
        displayLanguageSectionComponents: [
          "language_content_section_key",
          "campaign_profile_section_key",
          "checklist_key",
        ],
      }
    },
  languageSections: [
    {
      sectionContent: [
        {
          key: "language_content_section_key",
          complexComponent: ({
            formContext: { getValues },
            language
          }) => (
            <ContentLanguageCard language={language} campaignData={getValues()} />
          )
        },
      ],
    },
    {
      sectionContent: [{
        key: "campaign_profile_section_key",
        component: ProfileSection,
      }],
    },
    {
      sectionContent: [
        {
          key: "checklist_key",
          component: ApprovalCheckList
        },
      ]
    }
  ],
  normalSections: [],
}